import { LicenceDocument } from './LicenceDocument';
export class LicenceUploadInfo {
  public effectiveDate: number = 0;
  public expiryDate: number = 0;
  public documentFile: any;
  public licenceMasterId: number = 0;
  public licenceId: number = 0;
  public licenceName: string = "";
  public licenceCountry: string = "";
  public licenceAuthority: string = "";
  public licenceOn: string = "";
  public documents: LicenceDocument[] = [];
}
